import { LoadingOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Alert, Space } from 'antd';
import type React from 'react';
import { useCallback, useState } from 'react';
import { buildErrorDetails } from '../../../utils/ginoHelpers.ts';
import type { EcardConfig } from './EcardConfigs.tsx';
import { type ConnectionState, EcardConnectionCheck } from './EcardConnectionCheck.tsx';

export const EcardTest: React.FC<{ config: EcardConfig }> = ({ config }) => {
  const [connectionState, setConnectionState] = useState<ConnectionState>('pending');
  const [cardReaderConnectionError, setCardReaderConnectionError] = useState('');
  const [cardReaderConnectionState, setCardReaderConnectionState] = useState<'pending' | 'ok' | 'error'>('pending');

  const checkCardReaderConnection = useCallback(async () => {
    const response = await window.nativeApi!.ginoStatus(config.cardReaderAddress, {});

    if (!response.error) {
      setCardReaderConnectionState('ok');
    } else {
      setCardReaderConnectionState('error');
      setCardReaderConnectionError(
        `Die Verbindung zum Lesegerät ${config.cardReaderName} ist fehlgeschlagen. ${buildErrorDetails(response)}`
      );
    }
  }, [config]);

  const handleConnectionStateChange = (connectionState: ConnectionState) => {
    setConnectionState(connectionState);
    if (connectionState === 'ok') {
      checkCardReaderConnection();
    }
  };

  return (
    <Space
      orientation="vertical"
      className={css`
        width: 500px;
      `}
    >
      <EcardConnectionCheck connectionState={connectionState} onConnectionStateChanged={handleConnectionStateChange} />
      {connectionState === 'ok' && (
        <div>
          {cardReaderConnectionState === 'pending' && (
            <Alert showIcon icon={<LoadingOutlined />} type="info" title="Bitte warten, die Verbindung zum Kartenleser wird überprüft" />
          )}
          {cardReaderConnectionState === 'ok' && (
            <Alert showIcon type="success" title={`Die Verbindung zum Lesegerät ${config.cardReaderName} wurde erfolgreich hergestellt`} />
          )}
          {cardReaderConnectionState === 'error' && <Alert showIcon type="error" title={cardReaderConnectionError} />}
        </div>
      )}
    </Space>
  );
};
